import lodash from 'lodash';
import { getBikes, getCustomersId, getCustomersPostcode } from '../../Manage_retail/requests/get_leads_request';

async function getRefLeadCustomerFromCustomer(customer) {
    // search for customer that matches with phone number for get lead request
    const result = {};

    if (customer) {
        const customersId = await getCustomersId(customer);

        // if found any phone, add filter to where condition in get leads request
        if (customersId.result && customersId.options) {
            if (customersId.options.length) {
                result.ref_lead_customer = customersId.options.map((item) => item._id);
            } else {
                result.ref_lead_customer = null;
            }
        }
    }

    return result;
}

async function getRefLeadCustomerFromPostCode(post_code) {
    // search for customer that matches with postcode for get lead request
    const result = {};

    if (post_code) {
        const customersId = await getCustomersPostcode(post_code);

        // if found any phone, add filter to where condition in get leads request
        if (customersId.result && customersId.options) {
            if (customersId.options.length) {
                result.ref_lead_customer = customersId.options.map((item) => item._id);
            } else {
                result.ref_lead_customer = null;
            }
        }
    }
    return result;
}

async function getRefBikeLead(vrm, ref_bike_brand, ref_bike_model, mileageFrom, mileageTo, yearFrom, yearTo) {
    // search for bike variant with is set as hot
    const result = {};

    // search for bikes that matched on filters or/and vrm, bike brand and bike model, result will bikes id array
    // possible params: reg, bikeBrand, bikeModel, bikeVariantsId, mileageFrom, mileageTo, yearFrom, yearTo
    const hasBikeFilter = vrm
        || ref_bike_brand
        || (ref_bike_brand && ref_bike_model)
        || mileageFrom !== undefined
        || mileageTo !== undefined
        || yearFrom !== undefined
        || yearTo !== undefined;

    if (hasBikeFilter) {
        const bikesId = await getBikes({
            vrm,
            ref_bike_brand,
            ref_bike_model,
            mileageFrom,
            mileageTo,
            yearFrom,
            yearTo,
        });

        // if found any bike, add filter to where condition in get leads request
        if (bikesId.result && bikesId.options) {
            if (bikesId.options.length) {
                result.ref_bike_lead = bikesId.options.map((item) => item._id);
            } else {
                result.ref_bike_lead = null;
            }
        }
    }

    return result;
}

const memoizedGetRefLeadCustomerFromCustomer = lodash.memoize(getRefLeadCustomerFromCustomer);
const memoizedGetRefLeadCustomerFromPostCode = lodash.memoize(getRefLeadCustomerFromPostCode);
const memoizedGetRefBikeLead = lodash.memoize(getRefBikeLead, (...args) => JSON.stringify(args));

function* buildAsyncFiltersForLeads(filters, doNotCache) {
    if (doNotCache) {
        memoizedGetRefLeadCustomerFromCustomer.cache.clear();
        memoizedGetRefLeadCustomerFromPostCode.cache.clear();
        memoizedGetRefBikeLead.cache.clear();
    }

    const refLeadCustomerFromCustomer = yield memoizedGetRefLeadCustomerFromCustomer(filters.customer);
    const refLeadCustomerFromPostCode = yield memoizedGetRefLeadCustomerFromPostCode(filters.post_code);
    const refBikeLead = yield memoizedGetRefBikeLead(
        filters.vrm,
        filters.ref_bike_brand,
        filters.ref_bike_model,
        filters.mileageFrom,
        filters.mileageTo,
        filters.yearFrom,
        filters.yearTo,
    );

    return {
        ...filters, ...refLeadCustomerFromCustomer, ...refLeadCustomerFromPostCode, ...refBikeLead,
    };
}

export default buildAsyncFiltersForLeads;



// WEBPACK FOOTER //
// ./src/modules/Leads/shared/sagas/buildAsyncFiltersForLeads.saga.js